import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Validate URL before creating client to prevent crash
const isValidUrl = (url) => {
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false;
  }
};

let supabase = null;

if (SUPABASE_URL && SUPABASE_ANON_KEY && isValidUrl(SUPABASE_URL)) {
  supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true
    }
    // NOTE: Do NOT add a custom global.fetch with AbortController here.
    // Supabase internally manages its own abort signals for request lifecycle.
    // Overwriting the signal causes "signal is aborted without reason" errors
    // because our AbortController conflicts with Supabase's internal signal handling.
    // Application-level timeouts are handled in AuthContext via withTimeout().
  });
} else {
  console.error(
    '[Supabase] Invalid or missing credentials. ' +
    'Ensure VITE_SUPABASE_URL is a valid HTTPS URL and VITE_SUPABASE_ANON_KEY is set in your .env file.'
  );
}

export const isSupabaseConfigured = () => supabase !== null;

export default supabase;